export enum UserRole {
  ReadOnly = 'ReadOnly',
  User = 'User',
  Administrator = 'Administrator',
}

const roleLevel: Record<UserRole, number> = {
  [UserRole.ReadOnly]: 0,
  [UserRole.User]: 1,
  [UserRole.Administrator]: 2,
};

export type AccessRequirements = {
  currentRole?: UserRole;
  minimumRole?: UserRole;
  isSuperuser: boolean;
  requireSuperuser?: boolean;
};

export function hasAccess({
  currentRole,
  minimumRole,
  isSuperuser,
  requireSuperuser = false,
}: AccessRequirements): boolean {
  if (isSuperuser) {
    return true;
  }

  if (requireSuperuser && !isSuperuser) {
    return false;
  }

  if (minimumRole) {
    if (!currentRole) {
      return false;
    }

    if (roleLevel[currentRole] < roleLevel[minimumRole]) {
      return false;
    }
  }

  return true;
}

/**
 * Safely converts a raw account-role string from the API into a UserRole.
 * Returns undefined for unknown or absent values.
 */
export function parseUserRole(
  value: string | null | undefined,
): UserRole | undefined {
  if (!value) return undefined;
  return (Object.values(UserRole) as string[]).includes(value)
    ? (value as UserRole)
    : undefined;
}
